import { render, staticRenderFns } from "./NePanelBoardShow.vue?vue&type=template&id=fc762c50&"
import script from "./NePanelBoardShow.vue?vue&type=script&lang=js&"
export * from "./NePanelBoardShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports